module.exports = {"id":"228738","name":"Jhon Murillo","rating":"71","photo":"./data/images/photos/3/228738.png","club":{"name":"Kasimpaşa","logo":"./data/images/clubs/Kasimpasa.png"},"positions":["MD","BU","AD"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JhonMurillo0.json
// module id = 2016
// module chunks = 0